import {
  BookOpenIcon,
  ClipboardCheckIcon,
  LayersIcon,
  MapIcon,
  MegaphoneIcon,
  TargetIcon,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export const includedItems: { icon: LucideIcon; title: string; description: string }[] = [
  {
    icon: BookOpenIcon,
    title: '6 Complete Volumes',
    description: 'U8, U10, U12, U14, U17, plus a full Small-Sided Games and Season Plans volume.',
  },
  {
    icon: TargetIcon,
    title: '180+ Drills & Games',
    description: 'Each one with a setup diagram, duration, two progressions and the three mistakes to correct.',
  },
  {
    icon: LayersIcon,
    title: '48 Training Blocks',
    description: 'Eight per volume, always in the same order, so every session builds on the last.',
  },
  {
    icon: MegaphoneIcon,
    title: 'Coach Script Box',
    description: 'The exact words you say to the group, written out for you. Read it aloud and coach.',
  },
  {
    icon: MapIcon,
    title: 'Field Diagrams & A3 Posters',
    description: 'Full field, draw circle and 8-meter setup, ready to print and hang at the club.',
  },
  {
    icon: ClipboardCheckIcon,
    title: 'Assessment Built In',
    description: 'Rubrics, progress trackers and printable certificates already written for you.',
  },
]
